import { Component, OnInit, ViewEncapsulation, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TasksCreateFormComponent } from '../tasks-create/tasks-create-form/tasks-create-form.component';
import { TasksService } from 'app/services';
import { isEmpty, identity, pickBy } from 'lodash';
import { TimeLineDataService } from 'app/components/time-line/time-line-data.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

@Component({
  selector: 'app-tasks-create-modal',
  templateUrl: './tasks-create-modal.component.html',
  styleUrls: ['./tasks-create-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TasksCreateModalComponent implements OnInit {

  data: any = {};
  toggle = false as boolean;
  isClick = false as boolean;
  @ViewChild(TasksCreateFormComponent, { static: true }) tasksCreateForm: TasksCreateFormComponent;
  borderColor: string;

  constructor(
    public matDialogRef: MatDialogRef<TasksCreateModalComponent>,
    private _tasksService: TasksService,
    private _timeLineData: TimeLineDataService,
    private _fuseSidebarService: FuseSidebarService,
    @Inject(MAT_DIALOG_DATA) public _data: any
  ) {
    if (!isEmpty(this._data)) {
      this.data = this._data;
      if (this.data && this.data.data && this.data.data.color) {
        this.borderColor = this.data.data.color;
      } else if (this.data && this.data.color) {
        this.borderColor = this.data.color;
      }
    }
  }

  ngOnInit(): void {
    if (!isEmpty(this.data)) {
      if (this.data.relatedTo === 'update') {
        setTimeout(() => {
          if (this.data._id) {
            this._tasksService.getById(this.data._id).subscribe((data: any) => {
              this.tasksCreateForm.activity.patchValue(data);
              this.tasksCreateForm.patchFields(data);
            });
          }
          else {
            this.tasksCreateForm.activity.patchValue(this.data.data);
            this.tasksCreateForm.patchFields(this.data.data);
          }
        }, 200);
      } else if (this.data.relatedTo === 'calendar') {
        setTimeout(() => {
          this.tasksCreateForm.activity.get('start_date').setValue(this.data.date);
          this.tasksCreateForm.activity.get('end_date').setValue(this.data.date);
        }, 200);
      } else {

        if (this.data._id) {
          this.data = this.data._id;
        }
        this._tasksService.getById(this.data).subscribe((data: any) => {
          // this.tasksCreateForm.viewRecord = true;
          this.tasksCreateForm.activity.patchValue(data);
          this.tasksCreateForm.patchFields(data);
        });
      }
    }
  }

  submitForm(): void {
    if (this.tasksCreateForm.activity.valid) {
      if (this.borderColor) {
        this.tasksCreateForm.activity.get('color').setValue(this.borderColor);
      }
      if (!isEmpty(this.data)) {
        this.isClick = true;
        if (this.data.relatedTo === 'update') {
          if (this.borderColor) {
            this.tasksCreateForm.activity.get('color').setValue(this.borderColor);
          }
          let id = '';
          if(this.data && this.data._id && this.data._id != ''){
            id = this.data._id;
          } else if(this.data && this.data.data && this.data.data._id && this.data.data._id != ''){
            id = this.data.data._id;
          }
          this._tasksService.update(pickBy(this.tasksCreateForm.activity.getRawValue(), identity), id).subscribe((data: any) => {
            this.matDialogRef.close('refresh');
            this.isClick = false;
          }, (err: any) => {
            this.isClick = false;
          });
        }
        /**
         * In this.data i see that task id was comming from dasboard activites tab which was causing duplicate of tasks
         */
        else if ((typeof this.data) === 'string') {
          this._tasksService.update(pickBy(this.tasksCreateForm.activity.getRawValue(), identity), this.data).subscribe((data: any) => {
            this.matDialogRef.close('refresh');
          });
        }
        else {
          this.isClick = true;
          this._tasksService.create(pickBy(this.tasksCreateForm.activity.getRawValue(), identity)).subscribe((data: any) => {
            this.matDialogRef.close('refresh');
          }, (err: any) => {
            this.isClick = false;
          });
        }
      } else {
        this.isClick = true;
        this._tasksService.create(pickBy(this.tasksCreateForm.activity.getRawValue(), identity)).subscribe((data: any) => {
          this.matDialogRef.close('refresh');
        }, (err: any) => {
          this.isClick = false;
        });
      }
    } else {
      this.tasksCreateForm.activity.markAllAsTouched();
    }


  }
  onOpenTimeline(event: any): void {
    // event._id = this.route.snapshot.paramMap.get('id');
    this._timeLineData.setModelDataValue(event);
    this._timeLineData.setRelatedToValue('activities');
    this._fuseSidebarService.getSidebar('timeline').toggleOpen(1000000);
  }

}
